module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indicators),
      expression: "indicators"
    }],
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.indicator_list), function(indicator, i) {
    return _c('li', {
      class: {
        active: i === _vm.index
      },
      on: {
        "click": function($event) {
          _vm.indicatorClick(i)
        }
      }
    }, [_c('span')])
  })), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.controls),
      expression: "controls"
    }],
    staticClass: "carousel-controls hidden-xs"
  }, [_c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f20442cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f20442cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Carousel.vue
// module id = 94
// module chunks = 0